import { useState, useEffect } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  OrderRechargeCards,
  resetUpdateCreditCardBalanceForm,
  setUpdateCreditCardBalanceDialog,
} from "../../../../app/slices/orderRechargeCardsSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectSupplier } from "../../../../components/Selectors/SelectSupplier";
import { NumericFormat } from "react-number-format";
import { toNumber } from "../../../../helpers/toNumber";
import { HiOutlineCreditCard, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";
const UpdateCreditCardBalanceForm = () => {
  const dispatch = useDispatch();

  const _UpdateCreditCardBalance = useSelector(
    (state) => state.orderRechargeCards.updateCreditCardBalance
  );
  const _Supplier = useSelector((state) => state.supplier.suppliersList.data);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _UpdateCreditCardBalance.form,
  });

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(OrderRechargeCards.updateCreditCardBalance(data))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    reset({ ..._UpdateCreditCardBalance.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_UpdateCreditCardBalance.form]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdateCreditCardBalanceForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setUpdateCreditCardBalanceDialog());
  };

  return (
    <FormDialog
      open={_UpdateCreditCardBalance.dialog}
      onClose={() => {
        handleDialog();
      }}
      maxWidth="sm"
      icon={<HiOutlineCreditCard />}
      title="اضافة الرصيد"
      subtitle="اختر المورد وأدخل المبلغ لإضافة الرصيد"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_UpdateCreditCardBalance.loading}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات الرصيد">
        <Grid item xs={12} sm={6}>
          <Controller
            name="supplier_id"
            control={control}
            render={({ field }) => (
              <SelectSupplier
                required
                onChange={(e, newValue) => {
                  setValue("supplier_id", newValue ? newValue.id : null);
                }}
                value={
                  _Supplier.filter((x) => x.id === field.value)[0] ?? null
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name={"amount"}
            render={({ field }) => (
              <NumericFormat
                thousandSeparator
                customInput={TextField}
                value={field.value}
                onChange={(e) => {
                  setValue("amount", toNumber(e.target.value));
                }}
                valueIsNumericString={true}
                allowNegative={true}
                fullWidth
                label="المبلغ"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name={"note"}
            render={({ field }) => (
              <TextField
                {...field}
                label="ملاحظات"
                multiline
                rows={4}
                fullWidth
                size="small"
                variant="outlined"
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default UpdateCreditCardBalanceForm;
